/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "gvbma8f5g4",
            "endpoint": "https://gvbma8f5g4.execute-api.eu-west-2.amazonaws.com/truecaller",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:d2194a5f-25d9-4e0a-9ddd-4e2d16694219",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_2nq4oHQYo",
    "aws_user_pools_web_client_id": "ukkm0t6so3ff0he8aaj61chq1",
    "oauth": {
        "domain": "spamblocker-auth-truecaller.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SpamBlockerData-truecaller",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
